import styled, { css, keyframes, useTheme } from "styled-components";

const TrainLoaderIconContent = ({ ...props }) => {
  const theme = useTheme();
  const strokeColor = theme.trainSVGStrokeColor;
  const backgroundColor = theme.colorBackgroundMain;
  return (
    <svg
      width="600"
      height="262"
      viewBox="0 0 600 262"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2399_43088)">
        <rect width="600" height="262" fill={backgroundColor} />
        <path
          d="M389.5 181L444.493 254.5H334.507L389.5 181Z"
          fill={backgroundColor}
        />
        <path
          d="M437 243.146L392.902 184.21C391.702 182.607 389.298 182.607 388.098 184.21L344 243.146"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M334.5 143L414.607 248.75H254.393L334.5 143Z"
          fill={backgroundColor}
        />
        <path
          d="M403.693 232.415L338.348 146.157C337.148 144.572 334.766 144.572 333.565 146.157L268.22 232.415"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <g className="train">
          <rect x="100" y="195" width="76" height="42" fill={backgroundColor} />
          <rect x="183" y="195" width="76" height="42" fill={backgroundColor} />
          <path
            d="M266 237V195H325.5L329 197L357 220.5V228L348 237H266Z"
            fill={backgroundColor}
          />
          <path
            d="M93 237V195H33.5L30 197L2 220.5V228L11 237H93Z"
            fill={backgroundColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M73.7008 182.381C74.4601 181.821 75.6143 181.886 76.2787 182.525C76.9431 183.165 76.8662 184.137 76.1068 184.696L65.151 192.769H90.8894C93.1596 192.769 95 194.319 95 196.231V203.538V223.538V235.461C95 237.373 93.1596 238.923 90.8894 238.923H17.3289C7.7584 238.923 0 232.389 0 224.33C0 220.46 1.82571 216.748 5.0755 214.012L25.7527 196.599C28.6649 194.147 32.6147 192.769 36.7332 192.769H59.6022L73.7008 182.381ZM60.3208 195.846C60.2997 195.846 60.2786 195.846 60.2575 195.846H36.7332C33.5838 195.846 30.5633 196.9 28.3363 198.775L24.5065 202H36.5384C38.5564 202 40.1923 203.378 40.1923 205.077V223.538C40.1923 224.388 39.3743 225.077 38.3654 225.077H3.68214C4.13909 231.089 10.0743 235.846 17.3289 235.846H90.8894C91.1417 235.846 91.3462 235.674 91.3462 235.461V225.077H49.3269C48.3179 225.077 47.5 224.388 47.5 223.538V203.538C47.5 202.689 48.3179 202 49.3269 202H91.3462V196.231C91.3462 196.018 91.1417 195.846 90.8894 195.846H60.3208ZM91.3462 222V205.077H73.0769V222H91.3462ZM3.93666 222C4.47296 219.814 5.75691 217.789 7.65916 216.187L20.8527 205.077H36.5384V222H3.93666ZM69.4231 205.077V222H51.1538V205.077H69.4231ZM95 243.538C95 242.689 94.1821 242 93.1731 242H16.4423C15.4333 242 14.6154 242.689 14.6154 243.538C14.6154 244.388 15.4333 245.077 16.4423 245.077H93.1731C94.1821 245.077 95 244.388 95 243.538Z"
            fill={strokeColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M101.462 192.767C99.5499 192.767 98 194.317 98 196.229V203.537V223.538V235.461C98 237.373 99.5499 238.923 101.462 238.923H174.927C176.626 238.923 178.004 237.546 178.004 235.846V223.538V203.537V195.844C178.004 194.145 176.626 192.767 174.927 192.767H101.462ZM174.927 201.998V195.844H101.462C101.249 195.844 101.077 196.016 101.077 196.229V201.998H174.927ZM101.077 205.075V221.999H124.155V205.075H101.077ZM101.077 225.076V235.461C101.077 235.674 101.249 235.846 101.462 235.846H174.927V225.076H101.077ZM174.927 221.999V205.075H151.849V221.999H174.927ZM127.232 221.999V205.075H148.772V221.999H127.232ZM104.154 242C103.304 242 102.616 242.689 102.616 243.539C102.616 244.388 103.304 245.077 104.154 245.077H171.85C172.699 245.077 173.388 244.388 173.388 243.539C173.388 242.689 172.699 242 171.85 242H104.154Z"
            fill={strokeColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M184.466 192.767C182.554 192.767 181.004 194.317 181.004 196.229V203.537V223.538V235.461C181.004 237.373 182.554 238.923 184.466 238.923H257.931C259.63 238.923 261.008 237.546 261.008 235.846V223.538V203.537V195.844C261.008 194.145 259.63 192.767 257.931 192.767H184.466ZM257.931 201.998V195.844H184.466C184.253 195.844 184.081 196.016 184.081 196.229V201.998H257.931ZM184.081 205.075V221.999H207.159V205.075H184.081ZM184.081 225.076V235.461C184.081 235.674 184.253 235.846 184.466 235.846H257.931V225.076H184.081ZM257.931 221.999V205.075H234.853V221.999H257.931ZM210.236 221.999V205.075H231.776V221.999H210.236ZM187.158 242C186.308 242 185.62 242.689 185.62 243.539C185.62 244.388 186.308 245.077 187.158 245.077H254.854C255.703 245.077 256.392 244.388 256.392 243.539C256.392 242.689 255.703 242 254.854 242H187.158Z"
            fill={strokeColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M285.307 182.381C284.548 181.821 283.394 181.886 282.729 182.525C282.065 183.165 282.142 184.137 282.901 184.696L293.857 192.769H268.118C265.848 192.769 264.008 194.319 264.008 196.231V203.538V223.538V235.461C264.008 237.373 265.848 238.923 268.118 238.923H341.679C351.249 238.923 359.008 232.389 359.008 224.33C359.008 220.46 357.182 216.748 353.932 214.012L333.255 196.599C330.343 194.147 326.393 192.769 322.275 192.769H299.406L285.307 182.381ZM298.687 195.846C298.708 195.846 298.729 195.846 298.75 195.846H322.275C325.424 195.846 328.445 196.9 330.671 198.775L334.501 202H322.469C320.451 202 318.816 203.378 318.816 205.077V223.538C318.816 224.388 319.633 225.077 320.642 225.077H355.326C354.869 231.089 348.934 235.846 341.679 235.846H268.118C267.866 235.846 267.662 235.674 267.662 235.461V225.077H309.681C310.69 225.077 311.508 224.388 311.508 223.538V203.538C311.508 202.689 310.69 202 309.681 202H267.662V196.231C267.662 196.018 267.866 195.846 268.118 195.846H298.687ZM267.662 222V205.077H285.931V222H267.662ZM355.071 222C354.535 219.814 353.251 217.789 351.349 216.187L338.155 205.077H322.469V222H355.071ZM289.585 205.077V222H307.854V205.077H289.585ZM264.008 243.538C264.008 242.689 264.826 242 265.835 242H342.565C343.574 242 344.392 242.689 344.392 243.538C344.392 244.388 343.574 245.077 342.565 245.077H265.835C264.826 245.077 264.008 244.388 264.008 243.538Z"
            fill={strokeColor}
          />
        </g>
        <rect y="242" width="600" height="3" rx="1.5" fill={strokeColor} />
        <path
          d="M539.5 177L594.493 269.25H484.507L539.5 177Z"
          fill={backgroundColor}
        />
        <path
          d="M587 255L543.077 181.322C541.913 179.371 539.087 179.371 537.923 181.322L494 255"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <mask id="path-16-inside-1_2399_43088" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M442 120C449.39 120 456.212 117.571 461.713 113.468C466.82 122.727 476.677 129 488 129C504.569 129 518 115.569 518 99C518 82.4315 504.569 69 488 69C482.175 69 476.738 70.6601 472.136 73.5329C466.984 62.0208 455.428 54 442 54C426.146 54 412.904 65.1794 409.726 80.0849C394.22 81.2472 382 94.1966 382 110C382 126.569 395.431 140 412 140C425.078 140 436.202 131.632 440.308 119.957C440.868 119.986 441.433 120 442 120Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M442 120C449.39 120 456.212 117.571 461.713 113.468C466.82 122.727 476.677 129 488 129C504.569 129 518 115.569 518 99C518 82.4315 504.569 69 488 69C482.175 69 476.738 70.6601 472.136 73.5329C466.984 62.0208 455.428 54 442 54C426.146 54 412.904 65.1794 409.726 80.0849C394.22 81.2472 382 94.1966 382 110C382 126.569 395.431 140 412 140C425.078 140 436.202 131.632 440.308 119.957C440.868 119.986 441.433 120 442 120Z"
          fill={backgroundColor}
        />
        <path
          d="M461.713 113.468L464.34 112.019L462.678 109.005L459.919 111.063L461.713 113.468ZM472.136 73.5329L469.398 74.7584L470.804 77.9008L473.725 76.0777L472.136 73.5329ZM409.726 80.0849L409.95 83.0765L412.191 82.9085L412.66 80.7105L409.726 80.0849ZM440.308 119.957L440.459 116.961L438.221 116.848L437.478 118.962L440.308 119.957ZM459.919 111.063C454.919 114.793 448.722 117 442 117V123C450.058 123 457.506 120.349 463.507 115.872L459.919 111.063ZM488 126C477.814 126 468.94 120.36 464.34 112.019L459.086 114.917C464.699 125.095 475.541 132 488 132V126ZM515 99C515 113.912 502.912 126 488 126V132C506.225 132 521 117.225 521 99H515ZM488 72C502.912 72 515 84.0883 515 99H521C521 80.7746 506.225 66 488 66V72ZM473.725 76.0777C477.864 73.4937 482.753 72 488 72V66C481.597 66 475.612 67.8264 470.547 70.988L473.725 76.0777ZM442 57C454.203 57 464.711 64.2864 469.398 74.7584L474.874 72.3073C469.256 59.7552 456.654 51 442 51V57ZM412.66 80.7105C415.549 67.161 427.591 57 442 57V51C424.702 51 410.259 63.1978 406.792 79.4593L412.66 80.7105ZM385 110C385 95.7783 395.997 84.1224 409.95 83.0765L409.501 77.0933C392.442 78.3721 379 92.6149 379 110H385ZM412 137C397.088 137 385 124.912 385 110H379C379 128.225 393.775 143 412 143V137ZM437.478 118.962C433.781 129.473 423.766 137 412 137V143C426.391 143 438.622 133.79 443.138 120.953L437.478 118.962ZM442 117C441.483 117 440.969 116.987 440.459 116.961L440.157 122.954C440.767 122.984 441.382 123 442 123V117Z"
          fill={strokeColor}
          mask="url(#path-16-inside-1_2399_43088)"
        />
        <circle
          cx="92.9999"
          cy="106.449"
          r="18.6149"
          stroke={strokeColor}
          strokeWidth="3"
        />
        <path
          d="M92.9999 79.629V65"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M92.9999 149.117V134.488"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M76.8773 84.8674L68.2786 73.0322"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M117.721 141.084L109.123 129.249"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M66.913 98.5826L53 94.062"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M133 120.055L119.087 115.535"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M119.087 98.5821L133 94.0615"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M53 120.055L66.9131 115.535"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M109.123 84.8679L117.721 73.0327"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M68.2787 141.085L76.8774 129.25"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <rect x="428" y="104" width="100" height="40" fill={backgroundColor} />
        <rect x="358" y="109" width="100" height="40" fill={backgroundColor} />
        <path
          d="M542 103L470 103"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M383.5 108H331"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2399_43088">
          <rect width="600" height="262" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const TrainAnimation = keyframes`
  from {
    transform: translate(-380px, 0px);
  }
  to {
    transform: translate(100%, 0px);
  }
`;

const trainLoaderCSS = css`
  width: 600px;
  height: 262px;

  .train {
    transform: translate(-380px, 0px);
    animation: ${TrainAnimation} 3s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }
`;

export const TrainLoaderIcon = styled(TrainLoaderIconContent)`
  ${trainLoaderCSS}
`;
